import React from "react";
import styled from "styled-components";
import colorConfig from "../colorConfig";
import FooterLogo from "../Styling/Layout/FooterLogo";

const FooterComponent = (props) => {
  return (
    <>
    <ul>
      <li>
        <FooterLogo />
      </li>
      <li style={{ marginTop: "85px" }}>
        <Af href="https://www.kred.no/cookies/" target="_blank">
          Cookies
        </Af>
        <Af href="https://www.kred.no/personvernerklaering/" target="_blank">
          Personvern
        </Af>
      </li>
      <li>
        <Af href="https://www.kred.no/wp-content/uploads/2025/11/Redegjorelse-rundt-apenhetsloven-2024-signert.pdf" target="_blank">
          Åpenhetsloven
        </Af>
      </li>
    </ul>
      <ul>
        <li>
            <span>Bedrift</span>
        </li>
        <li>
          <Af href="/#/Login" target="_blank">
            Kundeportal
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/bli-kunde/" target="_blank">
            Bli kunde
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/artikler/vare-samarbeid/" target="_blank">
            Kundehistorier
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/integrasjon-okonomisystemer/" target="_blank">
            Integrasjoner
          </Af>
        </li>
      </ul>
      <ul>
        <li>
            <span>Om oss</span>
        </li>
        <li>
          <Af href="https://www.kred.no/kontakt/" target="_blank">
            Kontakt oss
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/artikler/nyheter/baerekraft/" target="_blank">
            Bærekraft
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/kredfondet/" target="_blank">
            Kredfondet
          </Af>
        </li>
        <li>
          <Af href="https://www.kred.no/nyheter/" target="_blank">
            Nyheter og aktuelt
          </Af>
        </li>
      </ul>                
    </>
  );
};

export default FooterComponent;

const Af = styled.a`
  font-family: "RM Neue", sans-serif;
  font-size: 20px;
  margin-right: 16px;
`;

const Pf = styled.p`
  color: ${colorConfig.midnatt_100};
  font-family: "RM Neue", sans-serif;
  font-size: 20px;
  font-weight: 400;
`;
